import React from 'react';
import { useOutletContext } from 'react-router';

import { useDebriefRouter } from 'ff/debrief/hooks';
import { useGetShareDetailsQuery } from 'ff/debrief/features/TracklogApi';
import { isSharedPage } from 'ff/debrief/utils';
import { RouteContext } from 'ff/debrief/router';
import { RouteContextType } from 'ff/debrief/router/RouteContext';

interface OutletContextType {
    setRouteContext: (value: RouteContextType) => void;
}

export const useRouteContext = (contextValue?: RouteContextType) => {
    const router = useDebriefRouter();
    const { page } = React.useContext(RouteContext);
    const outletContext = useOutletContext<OutletContextType>();

    React.useEffect(() => {
        if (contextValue && outletContext?.setRouteContext) {
            outletContext.setRouteContext(contextValue);
        }
    }, [contextValue?.page, outletContext?.setRouteContext]);

    const isShared = isSharedPage(page);
    const shareId = router.routeParams.shareId;
    const tracklogId = router.routeParams.tracklogId;

    const { currentData: share } = useGetShareDetailsQuery(shareId, {
        skip: !isShared || !shareId,
    });

    const selectedTracklogId = isShared ? share?.trackUuid : tracklogId;

    return {
        selectedTracklogId: selectedTracklogId,
        isShared: isShared,
    };
};
